import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {PageHeader} from 'antd';
import { pageSectionTitle } from '../util/Style';


import DoctorPayableStore from '../stores/DoctorPayableStore';
import RegistrationDetail from './RegistrationDetail';
import PendingInvoices from './PendingInvoices';


class DoctorSummary extends Component {

    constructor(props) {
        super(props);
        const referrerId = props.params.referrerId;
        const collectionType = props.params.collectionType;
        this.store = new DoctorPayableStore({ apiProxy: props.appStore.apiProxy, referrerId, collectionType });
    }

    render() {
        const doctorName = this.props.params.doctorName;

        return (
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(doctorName)}>
                <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: "5px" }}>
                    <div style={{ width: '60%' }}>
                        <PendingInvoices params={this.props.params} store={this.store} />
                    </div>
                    <div style={{ width: '40%' }}>
                        <RegistrationDetail store={this.store} />
                    </div>
                </div>
            </PageHeader>
        )
    }
}

export default observer(DoctorSummary)
